export const hybridspaceEmployee = "opkrb";
export const hybridspaceAdmin = "PkTAE";
export const hybridspaceViewAs = "tfiqY";
export default {hybridspaceEmployee,hybridspaceAdmin,hybridspaceViewAs};